import axios from "axios";
import { useMemo, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { baseUrl } from "../api";

export function useAxiosAuth() {
  const { user } = useContext(AuthContext);
  return useMemo(() => {
    const inst = axios.create({ baseURL: baseUrl });
    inst.interceptors.request.use(async cfg => {
      if (user) {
        cfg.headers.Authorization = `Bearer ${await user.getIdToken()}`;
      }
      return cfg;
    });
    return inst;
  }, [user]);
}
